import styled from 'styled-components';

export const FormContainer = styled.div`
  max-height: 550px;
  overflow: auto;

  &.disable-filter-builder {
    width: 500px;
    padding-top: 20px;

    .divider {
      display: none;
    }
  }
`;

export const AdvanceFilterBuilderContainer = styled.div`
  .dimension-value-container {
    width: 280px !important;
  }

  .error-input {
    border-color: rgb(202 34 22 / 70%) !important;

    .ant-select-selector {
      border-color: rgb(202 34 22 / 70%) !important;
    }
  }
`;

export const CategoryLabel = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Tips = styled.div`
  height: 0;
  width: 100%;
  border-top: 1px solid #d9d9d9;
  color: #999;
  padding: 12px 0 10px;
`;
